module.exports = __webpack_public_path__ + "static/assets/ccb5380ccdbd0effde3ed0e3411c6a5d.png";